import { FC } from "react";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { DataPoint } from "./types";
import { CustomXTick } from "./utility";

interface JobLineChartProps {
    dataPoints: DataPoint[];
    domain?: [number, number];
    xAxisLabel?: string;
    yAxisLabel: string;
    errorMessage?: string;
}

export const JobLineChart: FC<React.PropsWithChildren<JobLineChartProps>> = (props: JobLineChartProps) => {
    if (props.errorMessage) {
      return (<p className="text-danger">{props.errorMessage}</p>);
    }
    if (props.dataPoints.length === 0) {
        return <p>This chart - {props.xAxisLabel} vs {props.yAxisLabel} - does not contain any data for the last 30 days.</p>;
    }
    return (
        <ResponsiveContainer width="100%" height={350}>
            <LineChart
                width={400}
                height={350}
                data={props.dataPoints}
                margin={{
                    bottom: 50,
                    left: 20,
                    right: 30,
                    top: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                    dataKey="xAxisValue"
                    type="number"
                    domain={props.domain}
                    interval={0}
                    tick={<CustomXTick />}
                    height={30}
                    label={{ offset: 24, position: "bottom", value: props.xAxisLabel }}
                />
                <YAxis label={{ angle: -90, position: 'left', style: { "textAnchor": "middle" }, value: props.yAxisLabel }} />
                <Tooltip formatter={(value: string | number) => [value.toLocaleString("en-US"), props.yAxisLabel]} />
                {/* Color should match sass variable $qes-primary-blue */}
                <Line type="monotone" dataKey="yAxisValue" stroke="#056edf" activeDot={{ r: 8 }} />
            </LineChart>
        </ResponsiveContainer>
    );
}
